var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeverityIconsBackgroundWarning24(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Property 1=Medium (orange), SIze=24, Type=Fill and bg",
    filter: "url(#filter0_d_24505_201655)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1.5,
    width: 24,
    height: 24,
    rx: 6,
    fill: "#FEA339",
    fillOpacity: 0.08,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    id: "primary-shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.53583 6.66768C11.2267 5.66685 12.0717 5.16602 13 5.16602C13.9283 5.16602 14.7733 5.66602 16.4642 6.66768L17.0358 7.00602C18.7267 8.00768 19.5717 8.50852 20.0358 9.33268C20.5 10.1577 20.5 11.1577 20.5 13.161V13.8377C20.5 15.8402 20.5 16.8418 20.0358 17.666C19.5717 18.491 18.7267 18.991 17.0358 19.9918L16.4642 20.331C14.7733 21.3319 13.9283 21.8327 13 21.8327C12.0717 21.8327 11.2267 21.3327 9.53583 20.331L8.96417 19.9918C7.27333 18.9918 6.42833 18.4902 5.96417 17.666C5.5 16.841 5.5 15.841 5.5 13.8377V13.161C5.5 11.1577 5.5 10.1568 5.96417 9.33268C6.42833 8.50768 7.27333 8.00768 8.96417 7.00602L9.53583 6.66768ZM13.8333 16.8327C13.8333 17.0537 13.7455 17.2657 13.5893 17.4219C13.433 17.5782 13.221 17.666 13 17.666C12.779 17.666 12.567 17.5782 12.4107 17.4219C12.2545 17.2657 12.1667 17.0537 12.1667 16.8327C12.1667 16.6117 12.2545 16.3997 12.4107 16.2434C12.567 16.0871 12.779 15.9993 13 15.9993C13.221 15.9993 13.433 16.0871 13.5893 16.2434C13.7455 16.3997 13.8333 16.6117 13.8333 16.8327ZM13 8.70768C13.1658 8.70768 13.3247 8.77353 13.4419 8.89074C13.5592 9.00795 13.625 9.16692 13.625 9.33268V14.3327C13.625 14.4984 13.5592 14.6574 13.4419 14.7746C13.3247 14.8918 13.1658 14.9577 13 14.9577C12.8342 14.9577 12.6753 14.8918 12.5581 14.7746C12.4408 14.6574 12.375 14.4984 12.375 14.3327V9.33268C12.375 9.16692 12.4408 9.00795 12.5581 8.89074C12.6753 8.77353 12.8342 8.70768 13 8.70768Z",
    fill: "#FF8A00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_24505_201655",
    x: 0,
    y: 0.5,
    width: 26,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.996078 0 0 0 0 0.639216 0 0 0 0 0.223529 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_24505_201655"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_24505_201655",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeverityIconsBackgroundWarning24);
export default __webpack_public_path__ + "static/media/severity-icons-background-warning-24.7c8df7d11c7bded79523cfef32842e1b.svg";
export { ForwardRef as ReactComponent };